import { SearchParameters } from 'algoliasearch-helper'
import { type GetStaticProps, type NextPageWithLayout } from 'next'
import { useRouter } from 'next/router'
import React, { useEffect, useMemo, useState } from 'react'
import { InstantSearch } from 'react-instantsearch'
import TypesenseInstantSearchAdapter from 'typesense-instantsearch-adapter'
import { getPublicLayout } from '@public/components/PublicLayout'
import { ExpertsPageLayout } from 'components/InstantSearch/ExpertsPageLayout'
import { Seo } from 'components/Seo'
import { prepareGetStaticNavigationProps } from 'routes/utils/prepareGetStaticNavigationProps'
import { getTypesenseConfigurationOptions } from 'utils/typesenseClient'

const { searchClient } = new TypesenseInstantSearchAdapter({
  server: getTypesenseConfigurationOptions(),
  additionalSearchParameters: {
    query_by: 'profileName',
    include_fields:
      'id,profileName,profileImageUrl,profileImageAlt,jobTitle,location,legacyExpertId,headShotImageUrl,isTopExpert',
    sort_by: 'hasAvailability:desc,profileName:asc',
  },
})

export const FindAnExpert: NextPageWithLayout = () => {
  const router = useRouter()
  const [routingKey, setRoutingKey] = useState(0)

  // next link has problem with routing when navigate to the same page with different query params
  useEffect(() => {
    setRoutingKey((k) => k + 1)
  }, [router.asPath])

  const searchParameters = useMemo(
    () =>
      new SearchParameters({
        hitsPerPage: 32,
        filters: `isPublicVisible:=true`,
      }),
    []
  )

  return (
    <>
      <Seo
        title="Browse Top Interior Designers Online - The Expert"
        description="Browse and book online consultations with top interior designers like Jake Arnold and Leanne Ford. Our design services deliver real-time advice on renovations, layouts, furniture, and more."
      />
      <InstantSearch
        key={routingKey}
        searchClient={searchClient}
        indexName="experts-v4"
        routing
      >
        <ExpertsPageLayout searchParameters={searchParameters} />
      </InstantSearch>
    </>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  const baseProps = await prepareGetStaticNavigationProps()

  return {
    props: {
      ...baseProps.props,
    },
    revalidate: 24 * 3600,
    notFound: baseProps.notFound,
  }
}

FindAnExpert.getLayout = (page) =>
  getPublicLayout(page, { isWithBreadcrumbs: true, isFullWidth: true })
